export const PRIVACY_TERM = Object.freeze({
  title: '개인정보 수집·이용 동의',

  summary: `<주요사항 요약>
1. 스노로즈의 가입 및 이용을 위해 귀하의 개인정보가 수집됩니다.
2. 개인정보는 회원 탈퇴 후에도 일정 기간 보관·이용될 수 있습니다.
3. 개인정보는 제3자에게 제공될 수 있습니다. (정부기관, 제휴업체 등)

자세한 사항은 아래 약관에서 확인해주시기 바랍니다.`,

  guide: `스노로즈는 개인정보보호법에 의거하여, 아래와 같은 내용으로 개인정보를 수집하고 있습니다. 귀하께서는 아래 내용을 자세히 읽어 보시고, 모든 내용을 이해하신 후에 동의 여부를 결정해주시기 바랍니다.`,

  details: Object.freeze([
    {
      title: '1. 개인정보 수집 목적',
      content: `스노로즈는 아래와 같은 목적으로 개인정보를 수집·이용합니다. 해당 목적 외의 용도로는 이용하지 않으며, 이용 목적이 변경될 경우 사전 동의를 받습니다.
수집목적
- 회원제 서비스 제공, 개인식별, 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및 가입횟수 제한, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달, 회원탈퇴 의사의 확인.
- 양질의 서비스 제공 및 회원 개개인의 기호와 필요에 따른 맞춤화된 서비스를 제공해드리기 위함.
- 또한 기타 통계처리, 학술연구, 시장조사를 위하여 필요한 경우에는 특정한 개인을 식별할 수 없는 가공된 통계 자료의 형태로만 정보가 제공됩니다.`,
    },
    {
      title: '2. 개인정보의 수집 방법, 항목 및 범위',
      content: `스노로즈는 서비스의 이용을 위하여 회원 가입 시에 회원 정보를 기입하도록 합니다.
- 수집항목(필수) : 이름, 전화번호, 이메일, 학번 및 학적정보
필수항목의 수집·이용에 대해 거부하시는 경우 가입 및 서비스 이용이 제한됩니다.
특정 서비스 제공을 위해 추가 정보가 필요한 경우, 별도로 해당 내용을 고지하고 동의를 받습니다.`,
    },
    {
      title: '3. 개인정보의 처리 및 보유 기간',
      content: `스노로즈 회원의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적(사이트의 이용을 위한 정보 수집)이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 보존 이유를 위해 명시기간 동안 보존합니다.
부정이용기록 (부정가입, 경고 및 징계(강등)기록 등의 부정 서비스 이용기록)
- 보존 항목 : 회원가입 시의 기본 필수 정보 및 경고 및 징계 사유 기록
- 보존 기간 : 영구강등 시 강등 시점으로부터 10년간
- 보존 이유 : 재가입 방지를 위해 기록 보존
로그인 기록 (정상적 서비스 이용기록)
- 보존 항목 : 사이트 방문 기록
- 보존 기간 : 3개월
- 보존 이유 : 고객의 불만/민원 처리, 소송 등 분쟁이 진행 중이거나 예상되는 경우를 위하여`,
    },
    {
      title: '4. 개인정보의 제3자 공유 및 제공',
      content:
        '스노로즈는 원칙적으로 회원의 개인정보를 어느 누구와도 공유하지 않습니다. 다만 회원님이 공개를 동의한 경우 또는 스노로즈 이용자 약관을 위배하거나 타인에게 피해를 주는 행위 등으로 법적인 조치가 요구되고 적법한 절차에 의해 관련 정부 기관의 요구가 있을 경우에는 예외로 합니다. 스노로즈는 보다 나은 서비스의 제공을 위해 회원의 개인정보를 제휴업체와 일부 공유할 수 있으나, 이 경우에도 정보수집 또는 정보제공 이전에 제휴업체 정보, 요청되는 정보의 종류, 정보의 보호 및 관리 방안에 대하여 알리고 동의를 구하는 절차를 거치며, 회원이 동의하지 않는 경우에는 수집 및 공유하지 않습니다.',
    },
    {
      title: '5. 자신의 개인정보 열람, 수정 및 삭제',
      content:
        '스노로즈의 회원은 언제든지 자신의 개인정보를 열람하거나 수정할 수 있으며, 회원탈퇴를 통해서 개인정보의 삭제를 요청할 수 있습니다. 개인정보의 열람, 수정은 스노로즈 마이페이지에서 하실 수 있으며, 특수 수정사항(학번, 이름)은 운영진에게 요청 시 수정이 가능합니다. ',
    },
    {
      title: '6. 개인정보의 보유 및 이용 기간',
      content: `스노로즈의 회원으로서 스노로즈 서비스를 제공받는 동안 스노로즈는 개인정보를 계속 보관하고 서비스의 제공을 위해 이용합니다. 회원 등록해지 및 또는 스노로즈 이용자 약관에 의거한 아이디 삭제의 경우, 기존에 수집된 개인정보는 재생할 수 없도록 하드디스크에서 완전히 삭제되며 어떠한 용도로도 열람, 이용할 수 없게 처리됩니다.
탈퇴 회원의 개인정보 이용
- 스노로즈는 회원정보를 회원이 탈퇴하는 시점으로부터 1년까지 보유할 수 있습니다.
    - 회원식별정보
        - 보존 항목: 이름, 학번, 이메일
        - 보존 기간: 탈퇴 후 1년
    - 스노로즈가 보관하고 있는 탈퇴 회원의 정보는 회원의 가입 이력 관리와 지적재산권 관리, 개인정보 보호를 위해서만 활용할 수 있습니다.
    - 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 스노로즈는 아래와 같이 관계법령에서 정한 기간동안 회원정보를 보관합니다.
        - 이용자 불만 또는 분쟁 처리에 관한 기록 : 5년
        - 계약 또는 청약철회 등에 관한 기록 : 5년
        - 대금결제 및 재화 등의 공급에 관한 기록 : 5년`,
    },
    {
      title: '7. 강제탈퇴된 유저의 재가입 불허',
      content:
        '스노로즈의 서비스 이용 중 사용자가 준수해야 하는 사항의 위반으로 강제탈퇴된 경우 재가입이 불허될 수 있습니다.',
    },
    {
      title: '8. 스노로즈의 개인정보 보호',
      content: `스노로즈의 개인정보는 기본적으로 회원의 아이디와 비밀번호에 의하여 보호됩니다.
개인정보의 열람 및 수정은 해당 아이디와 비밀번호를 알고 있는 본인만이 가능합니다.
본인이 자신의 아이디와 비밀번호를 유출하였다면 이에 대해서 스노로즈는 책임을 지지 않습니다. 
스노로즈는 해킹 등에 의한 정보 유출의 방지, 보안 및 재난 등의 정보 훼손 방지를 위한 데이터 백업 등의 기술적 관리에도 최선을 다하고 있습니다. 또한 스노로즈는 이용자 본인의 비밀번호 요청 등에 의해 개인정보를 취급할 때가능한 최선의 방법으로 본인임을 확인하고 안전하게 정보가 처리될 수 있도록 최선을 다합니다. 그리고 개인정보 관리 권한을 가진 관리자를 최소화하고 지속적인 교육을 통하여 개인정보보호정책을 준수하고 있습니다.
스노로즈의 개인정보는 기본적으로 본인이 설정한 아이디와 비밀번호에 의해 보호되며, 개인정보의 열람 및 수정은 원칙적으로 본인만 가능합니다. 단, 관리 및 제재가 필요한 경우 운영진의 열람이 허용됩니다.`,
    },
    {
      title: '9. 개인정보 보호(관리) 책임자',
      content: `스노로즈는 개인정보 처리에 관한 업무를 총괄하여 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
- 개인정보 보호책임자: 스노로즈 운영진 회장 (약 1년마다 변경됨)
- 연락처: smsnorose@gmail.com`,
    },
    {
      title: '10. 개인정보 처리방침 변경 및 고지',
      content:
        '이 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지하겠습니다.',
    },
    {
      title: '11. 기타',
      content: `채팅, 게시판, 이메일 등을 통해 자신이 자발적으로 제공하는 개인정보는 다른 사람들에 의하여 본인의 의도와는 다르게 이용될 수 있다는 사실을 염두에 두어야 합니다.
타인에게 공개되어 있는 장소에서는 자신의 개인정보를 함부로 남겨서는 안됩니다.
또한 PC방이나 기타 공공장소 등 주변에 사람들이 많은 곳에서는 서비스를 이용하고 있는 동안 다른 사람들이 자신의 컴퓨터 화면을 볼 수도 있다는 사실을 염두에 두고 개인정보가 노출되지 않도록 주의하여야 합니다.
따라서 아이디 및 비밀번호 유출 방지를 위해 다음의 유의사항에 따라 활동하실 것을 권장드립니다. 해당 아이디와 비밀번호는 절대 본인만이 사용하시고, 비밀번호를 자주 바꿔주시는 것이 좋습니다. 또한 비밀번호는 영문자, 숫자, 특수문자를 혼합하여 타인이 유추하기 어려운 번호를 사용하는 것이 좋습니다. 스노로즈 서비스의 이용을 마친 후에는 항상 로그아웃을 해주시고 웹브라우저를 닫아주시는 것이 좋습니다. 특히, 다른 사람과 컴퓨터를 공유하거나, 공공장소에서 이용하는 경우에 개인정보의 보안을 위해서는 이와 같은 절차가 더욱 필요합니다.`,
    },
  ]),
  notice: `※ 위의 개인정보 수집·이용에 대한 내용을 모두 확인하였으며, 이에 동의합니다.

귀하는 개인정보 수집·이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부하실 경우 회원 가입이 제한될 수 있습니다.

2025년 10월 6일`,
});
